import { render, staticRenderFns } from "./pause_list.vue?vue&type=template&id=451fd2c4&scoped=true"
import script from "./pause_list.vue?vue&type=script&lang=js"
export * from "./pause_list.vue?vue&type=script&lang=js"
import style0 from "./pause_list.vue?vue&type=style&index=0&id=451fd2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fd2c4",
  null
  
)

export default component.exports